<script lang="ts">
  export let activeDot = 0;
  export let amountDots = 0;
  export let carouselStage: HTMLElement;

  /*                                              */
  export let amountVisibleDots = 0;

  const moveToSlide = (activeDot: number) => {
    carouselStage?.scrollTo({
      left: Math.floor(carouselStage.scrollWidth * (activeDot / amountDots)),
    });
  };
</script>

{#if amountDots > 1}
  <ul class="paginationdots" aria-hidden="true">
    {#each Array(amountDots) as _, key}
      <li
        class="paginationdots__item"
        class:paginationdots__item--active={activeDot === key}
        on:click={() => moveToSlide(key)}
        title="Go to slide {key + 1}"
      ></li>
    {/each}
  </ul>
{/if}

<style lang="scss" global>
  @use "@otto-ec/design-tokens/tokens";

  .paginationdots {
    padding: 0;
    margin: 0 auto;
    margin-top: 8px;
    display: flex;
    gap: tokens.$oc-component-pagination-dot-gap-x;
    justify-content: center;
    list-style: none;
    -webkit-tap-highlight-color: transparent;

    &__item {
      cursor: pointer;
      border-radius: 50%;
      border: none;
      padding: 0;
      width: tokens.$oc-component-pagination-dot-size-default;
      height: tokens.$oc-component-pagination-dot-size-default;
      background-color: tokens.$oc-component-pagination-dot-default;
      transition: background-color 0.2s ease-in-out;

      &--active {
        background-color: tokens.$oc-component-pagination-dot-selected;
        cursor: pointer;
      }

      @media (hover: hover) {
        &:hover {
          background-color: tokens.$oc-component-pagination-dot-hover;
        }
      }
    }
  }
</style>
